import React from 'react'
import ScrollTable from '@/components/scrollTable'
import DateTimePicker from '@/components/DateTimePicker'
import Slider from '@/components/slider'
import SliderComponent from 'react-slick'
import Swiper from '@/components/swiper'
import { Col, Row, Image, Button, Table, Select, Carousel, Modal, message, Spin } from 'antd'
import { useState, useEffect, createRef } from 'react'
import { Document, Page, pdfjs } from 'react-pdf'
import 'react-pdf/dist/esm/Page/AnnotationLayer.css'
// 设置 pdfjs 的 worker 路径
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`
// 添加字体加载配置，忽略字体映射错误
pdfjs.GlobalWorkerOptions.workerOptions = {
  disableFontFace: true // 禁用字体加载以避免字体映射错误
}
import {
  CheckOutlined,
  SearchOutlined,
  ArrowLeftOutlined,
  CloseCircleOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  RightOutlined,
  CaretDownOutlined,
  ToTopOutlined,
  CloseOutlined
} from '@ant-design/icons'
import MenuImg from '@/assets/img/home/menu.png'
import VideoImg from '@/assets/img/home/video.png'
import ShiwuImg from '@/assets/img/home/shiwu.png'
import EWMImg from '@/assets/img/home/ewm.png'
import PhoneImg from '@/assets/img/home/phone.png'
import NoDataImg from '@/assets/img/home/noData.png'
import btmBgImg from '@/assets/img/home/btmBg.png'
import fireBgImg from '@/assets/img/home-goods/fire.png'
import fireBg from '@/assets/img/home-goods/fire1.png'
import fireCornerImg from '@/assets/img/home-goods/fire-corner.png'
import fireRedCornerImg from '@/assets/img/home-goods/fire-red.png'
import fireHealth from '@/assets/img/home-goods/health-icon.png'
import hotBg from '@/assets/img/home/hot_bg.png'

// import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css'

import PageFooter from '@/components/sc/PageFooter'
import './index.less'
import api from '@/net/api'
import moment from 'moment'
import _ from 'lodash'
import { useDispatch, useSelector } from 'react-redux'
import { API_EWM_BASEURL } from '@/constant'
import QRCode from 'qrcode.react'
import storeUser, { sysuserInfoSlice, btmImgSlice } from '@/store'
// import storeUser from '@/store'

export default function Home(props) {
  let { location, history, route } = props
  const dispatch = useDispatch()
  const { Option } = Select
  const [isSearch, setIsSearch] = useState(false)
  const [banner, setBanner] = useState([])
  // loading
  const [loading, setLoading] = useState(false)
  const [dataList, setDataList] = useState([])
  const [dataSource1, setDataSource1] = useState([])
  const [dataSource2, setDataSource2] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [goodInfo, setGoodInfo] = useState(null)

  const [list, setList] = useState([])
  const [restaurant, setRestaurant] = useState([])
  const [store, setStore] = useState([])
  const { buyerOrgId: orgRegionId, screenPriceShow, id } = storeUser.getState().sysuserInfo

  const [isOpen, setIsOpen] = useState(false)
  const [zoom, setZoom] = useState(1)
  const [imgPX, setImgPX] = useState({ width: 1080, height: 485 })
  const [right, setRight] = useState(0)
  const [configValue, setConfigValue] = useState([2, 2, 2])
  const [selectedHotWindowList, setSelectedHotWindowList] = useState([])
  const [hotSaleWindowList, setHotSaleWindowList] = useState([])
  const [customPicList, setCustomPicList] = useState([null, null, null])

  // let dbtPicUrl = 'https://cdn.rongdaufun.com/spa/other/scImgs/yyzc.png'
  const [dbtPicUrl, setDbtPicUrl] = useState([{ url: 'https://cdn.rongdaufun.com/spa/other/scImgs/yyzc.png' }])
  const [curDbtPicUrl, setCurDbtPicUrl] = useState('https://cdn.rongdaufun.com/spa/other/scImgs/yyzc.png')

  // let params = location.search.split('?id=')[1]
  // console.log(params)
  // let rid = id?id:Base64.decode(params)
  // console.log(location.search,rid)

  // 搜索条件
  const [searchParams, setSearchParams] = useState({
    startDate: moment().subtract(1, 'd').hour(0).minute(0).second(0),
    endDate: moment().hour(23).minute(59).second(59),
    restaurantId: null,
    storeId: null,
    productName: null,
    orgRegionIds: orgRegionId
  })
  // 分页
  const [page, setPage] = useState({
    currentPage: 1,
    pageSize: 6,
    total: 0
  })
  // 显示检验报告
  async function showExaminition(record) {
     setLoading(true)
    if(record.supplierContractType == 'PDF'){
      // 创建 record 的深拷贝
      const newRecord = JSON.parse(JSON.stringify(record))
      const urls = newRecord.supplierContractUrls.split(',')
      const secureUrls = urls.map(url => url.replace('http://', 'https://'))

      try {
        const allImagesPromises = secureUrls.map(async url => {
          const images = await convertPdfToImage(url, 0.8) // 设置缩放比例为 0.8
          return images
        })
        const supplierContractUrlsToImages = await Promise.all(allImagesPromises)
        newRecord.supplierContractUrlsToImages = supplierContractUrlsToImages
        console.log('supplierContractUrlsToImages', newRecord.supplierContractUrlsToImages)
        setGoodInfo(newRecord)
      } catch (error) {
        console.error('PDF 转换出错:', error)
        message.error('PDF 转换失败，请稍后重试')
      }
      setIsModalOpen(true)
      setLoading(false)
    }else{
      setGoodInfo(record)
      setIsModalOpen(true)
      setLoading(false)
    }
    
  }
  const columns = [
    {
      title: '商品名称',
      dataIndex: 'productName',
      render: (text, record, index) => {
        return (
          <div>
            <Row
              className="outer-box"
              onClick={e => {
                showExaminition(record)
              }}>
              <Col>
                <Image className="inner-image" preview={false} width={153} src={record.picUrl} />
              </Col>
              <Col className="inner-cnt">
                <Row className="row-flex">
                  <Col>
                    <div className="goods-name">{text}</div>
                    <div className="goods-restarount">
                      {record.buyerRestaurantName}——{record.buyerStoreName}
                    </div>
                    <div className="goods-time">采购时间：{record.createTime}</div>
                  </Col>
                  {screenPriceShow != 'ON' ? (
                    <Col className="is-upload">
                      {record.examiningReportPicUrl && (
                        <>
                          <CheckOutlined style={{ color: '#31ADA5', fontSize: '24px' }} />
                          <span style={{ color: '#31ADA5' }}>已上传</span>
                        </>
                      )}
                      {!record.examiningReportPicUrl && (
                        <>
                          <ToTopOutlined style={{ color: '#31ADA5', fontSize: '24px' }} />
                          <span style={{ color: '#31ADA5' }}>未上传</span>
                        </>
                      )}
                    </Col>
                  ) : (
                    <Col className="is-upload">
                      <span style={{ color: '#31ADA5' }}>{'¥' + window.$util.toFixed2(record.payableUnitPrice) + '/' + record.unitName}</span>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </div>
        )
      }
    }
  ]
  useEffect(() => {
    let params = location.search.split('?id=')[1]
    // let params = new URLSearchParams(location.search);
    console.log(params)
    // let rid = parseInt(params.get('id'))
    let rid = Base64.decode(params)
    let timer
    // 获取学校/组织信息
    api
      .display_info({ rid })
      .then(d => {
        setSearchParams({ ...searchParams, orgRegionIds: d.buyerOrgId })
        dispatch(sysuserInfoSlice.actions.save(d))
        getList(d.buyerOrgId)
        getBanner(d.buyerOrgId)
        getRestaurantList({
          orgRegionIds: d.buyerOrgId
        })
        getProductNameList({
          restaurantId: null,
          storeId: null,
          productName: null,
          orgRegionIds: d.buyerOrgId
        })
        getPageDetail(rid)
        timer = setInterval(() => {
          if (!isSearch) {
            getList(d.buyerOrgId)
          }
        }, 24 * 60 * 60 * 1000) //
      })
      .catch(err => { })

    return () => {
      clearInterval(timer)
    }
  }, [])

  // 获取餐厅
  function getRestaurantList(query) {
    let p = {
      startDate: searchParams.startDate,
      endDate: searchParams.endDate,
      orgRegionIds: searchParams.orgRegionIds,
      ...query
    }
    if (p.startDate && typeof p.startDate !== 'string') {
      p.startDate = p.startDate.format('YYYY-MM-DD')
      p.endDate = p.endDate.format('YYYY-MM-DD')
    }
    api.get_foodTraceability_restaurantList(p).then(res => {
      setRestaurant(res || [])
    })
  }
  // 获取门店
  function getStoreList(restaurantId) {
    setSearchParams({ ...searchParams, restaurantId })
    let selectRestaurant = restaurant.filter(item => item.buyerRestaurantId == restaurantId)
    let storeList = selectRestaurant[0]?.storeList || []
    setStore(storeList)
  }
  // 获取商品名称列表
  function getProductNameList(params) {
    let p = {
      ...searchParams,
      ...params
    }

    if (p.startDate && typeof p.startDate !== 'string') {
      p.startDate = p.startDate.format('YYYY-MM-DD')
      p.endDate = p.endDate.format('YYYY-MM-DD')
    }

    api.get_foodTraceability_productNameList(p).then(res => {
      let data = []
      if (res) {
        res?.map((item, index) => {
          data.push({
            label: item,
            value: index
          })
        })
      }

      console.log('list', list)
      setList(data || [])
    })
  }

  // useEffect(()=>{
  //   console.log(1111)
  //   getProductNameList()
  // },[searchParams.restaurantId,searchParams.storeId])
  // 获取滚动列表

  async function getList(id) {
    let orgRegionIds = id || searchParams.orgRegionIds

    let p = {
      currentPage: 1,
      orgRegionIds,
      pageSize: 30
    }
    if (searchParams.startDate && typeof searchParams.startDate !== 'string') {
      p.startDate = searchParams.startDate.format('YYYY-MM-DD')
      p.endDate = searchParams.endDate.format('YYYY-MM-DD')
    }

    setLoading(true)
    api.get_foodTraceability_list(p).then(res => {
      let _dataSource1 = []
      let _dataSource2 = []
      let list = res?.list || []
      // let copyList = _.cloneDeep(list)
      list.map((item, i) => {
        if (i % 2 == 0) {
          _dataSource1.push(item)
        } else {
          _dataSource2.push(item)
        }
      })
      if (_dataSource1.length > 4) {
        _dataSource1 = _dataSource1.concat(_dataSource1)
      }
      if (_dataSource2.length > 4) {
        _dataSource2 = _dataSource2.concat(_dataSource2)
      }
      console.log('轮播商品数据', _dataSource1, _dataSource2)
      setDataSource1(_dataSource1)
      setDataSource2(_dataSource2)
      setLoading(false)
    })
  }
  // 获取展厅相关信息
  async function getPageDetail(rid) {
    api.get_display_id(rid).then(res => {
      if (res.length > 0) {
        let _customPicList = _.cloneDeep(customPicList)
        let _configValue = _.cloneDeep(configValue)
        res.map(async tabItem => {
          if (tabItem.infoType == 'RMCK') {
            let keyIndex = tabItem.contentType == '0' ? 1 : 2
            _configValue[0] = keyIndex
            if (tabItem.contentType == '0') {
              _customPicList[0] = null
            } else {
              _customPicList[0] = JSON.parse(tabItem.content)
            }
            try {
              const healList = await getHealList() // 等待 getHealList 执行完成

              if (healList.length > 0) {
                // 当 getHealList 返回有效数据时的处理逻辑
                //如果有健康证先走健康证逻辑
                _configValue[0] = 1
                // if (tabItem.contentType == '0') {
                //   _customPicList[0] = null;
                // } else {
                //   // _customPicList[0] = healList;
                //   _customPicList[0] = null;
                // }
                setSelectedHotWindowList(healList)
              } else {
                if (tabItem.contentType == '0') {
                  setSelectedHotWindowList(JSON.parse(tabItem.content))
                  // _customPicList[0] = null;
                } else {
                  // _customPicList[0] = JSON.parse(tabItem.content);
                }
              }
            } catch (error) {
              console.error('getHealList 出错', error)
              if (tabItem.contentType == '0') {
                setSelectedHotWindowList(JSON.parse(tabItem.content))
                _customPicList[0] = null
              } else {
                _customPicList[0] = JSON.parse(tabItem.content)
              }
            }
          } else if (tabItem.infoType == 'RXSP') {
            let keyIndex = tabItem.contentType == '0' ? 1 : 2
            _configValue[1] = keyIndex
            if (tabItem.contentType == '0') {
              setHotSaleWindowList(JSON.parse(tabItem.content))
              _customPicList[1] = null
            } else {
              _customPicList[1] = JSON.parse(tabItem.content)
            }
          } else {
            let picUrl = JSON.parse(tabItem.content)
            _customPicList[2] = picUrl
            // dbtPicUrl = picUrl[0].url
            setDbtPicUrl(picUrl)
            dispatch(btmImgSlice.actions.save(picUrl))
          }
        })
        setConfigValue(_configValue)
        setCustomPicList(_customPicList)
      }
    })
  }
  async function getHealList() {
    return new Promise((resolve, reject) => {
      api.get_heath_list({ buyerOrgId: storeUser.getState().sysuserInfo.buyerOrgId }).then(res => {
        if (res) {
          resolve(res)
        } else {
          reject(res)
        }
      })
    })
  }
  // 获取搜索列表
  async function getPageList(q) {
    let p = {
      ...searchParams,
      ...page,
      ...q
    }

    if (p.startDate && typeof p.startDate !== 'string') {
      p.startDate = p.startDate.format('YYYY-MM-DD')
      p.endDate = p.endDate.format('YYYY-MM-DD')
    }

    setLoading(true)
    setIsSearch(true)
    api.get_foodTraceability_list(p).then(res => {
      let list = res?.list
      setDataList(list)
      setLoading(false)
      setPage({
        ...page,
        currentPage: p.currentPage,
        total: res.total
      })
    })
  }
  // 页码改变时
  function pageChange(currentPage) {
    getPageList({
      currentPage,
      pageSize: page.pageSize
    })
  }
  function getBanner(orgRegionId) {
    api
      .popularization_list({
        type: 'USER',
        orgRegionId,
        currentPage: 1,
        pageSize: 3
      })
      .then(res => {
        let list = res?.list
        setBanner(list)
      })
  }
  function goPage(path) {
    props.history.push(path)
  }
  //拖拽的实现
  function onDrag() {
    let obj = document.querySelector('.slick-active .img')
    console.log(obj)
    if (!obj) return
    // // 鼠标被按下
    // obj.ontouchstart  = (event) => {
    //   event = event || window.event
    //   // 阻止默认事件
    //   event.preventDefault()

    //   // 计算鼠标当前坐标 = 鼠标按下坐标 - 元素当前坐标(距离父元素距离)
    //   // div的水平偏移量  鼠标.clentX - 元素.offsetLeft
    //   // div的垂直偏移量  鼠标.clentY - 元素.offsetTop
    //   var ol = event.changedTouches[0].clientX - obj.offsetLeft
    //   var ot = event.changedTouches[0].clientY - obj.offsetTop
    //   // 绑定鼠标移动事件
    //   document.ontouchmove = (event2) => {
    //     event2 = event2 || window.event;
    //     // 计算移动距离 = 当前鼠标坐标 - 鼠标按下坐标
    //     var left = event2.changedTouches[0].clientX - ol
    //     var top = event2.changedTouches[0].clientY - ot
    //     let scale = obj.style.transform.substring(6,obj.style.transform.length-1)
    //     if(obj.style.transform){
    //       if(scale>1){
    //         if(left<0){
    //           if(Math.abs(left) >= window.screen.width*(scale-1)/2){
    //             left = -(window.screen.width*(scale-1)/2)
    //           }
    //         }else{
    //           if(Math.abs(left) >= window.screen.width*(scale-1)/2){
    //             left = window.screen.width*(scale-1)/2
    //           }
    //         }
    //         if(scale>=3){
    //           if(top<=100){
    //             top = 100
    //           }else if(top>=500){
    //             top = 500
    //           }
    //         }

    //         obj.style.left = parseInt(left, 10) + "px"
    //         obj.style.top = parseInt(top, 10) + "px"
    //         obj.style.position = 'absolute'
    //       }else{
    //         obj.style.left = "0px"
    //         obj.style.top = parseInt(top, 10) + "px"
    //         obj.style.position = 'absolute'
    //       }

    //     }

    //   }

    //   // 绑定一个鼠标松开事件
    //   document.ontouchend  = () => {
    //     // 取消鼠标移动事件
    //     document.ontouchmove  = null;
    //     // document.onmouseup  = null;
    //   }
    // }
    // 鼠标被按下
    obj.ondragstart = event => {
      event = event || window.event
      // 阻止默认事件
      event.preventDefault()

      // 计算鼠标当前坐标 = 鼠标按下坐标 - 元素当前坐标(距离父元素距离)
      // div的水平偏移量  鼠标.clentX - 元素.offsetLeft
      // div的垂直偏移量  鼠标.clentY - 元素.offsetTop
      var ol = event.clientX - obj.offsetLeft
      var ot = event.clientY - obj.offsetTop
      // 绑定鼠标移动事件
      document.ondrag = event2 => {
        event2 = event2 || window.event
        // 计算移动距离 = 当前鼠标坐标 - 鼠标按下坐标
        var left = event2.clientX - ol
        var top = event2.clientY - ot
        console.log(event2, left)
        let scale = obj.style.transform.substring(6, obj.style.transform.length - 1)
        if (obj.style.transform) {
          if (scale > 1) {
            if (left < 0) {
              if (Math.abs(left) >= (window.screen.width * (scale - 1)) / 2) {
                left = -((window.screen.width * (scale - 1)) / 2)
              }
            } else {
              if (Math.abs(left) >= (window.screen.width * (scale - 1)) / 2) {
                left = (window.screen.width * (scale - 1)) / 2
              }
            }
            if (scale >= 3) {
              if (top <= 100) {
                top = 100
              } else if (top >= 500) {
                top = 500
              }
            }

            obj.style.left = parseInt(left, 10) + 'px'
            obj.style.top = parseInt(top, 10) + 'px'
            obj.style.position = 'absolute'
          } else {
            obj.style.left = '0px'
            obj.style.top = parseInt(top, 10) + 'px'
            obj.style.position = 'absolute'
          }
        }
      }

      // 绑定一个鼠标松开事件
      document.ondragend = () => {
        // 取消鼠标移动事件
        document.ondrag = null
        document.ondragend = null
      }
    }
  }
  //点击控制图片缩放
  function imgToSize(flag) {
    let imgDom = document.querySelector('.slick-active .img')
    let _zoom = zoom
    if (flag) {
      _zoom = (parseInt(_zoom * 100) + 50) / 100 >= 5 ? 5 : (parseInt(_zoom * 100) + 50) / 100
    } else {
      _zoom = (parseInt(_zoom * 100) - 50) / 100 <= 0.1 ? 0.1 : (parseInt(_zoom * 100) - 50) / 100
    }
    if (_zoom >= 1) {
      if (_zoom >= 3.5) {
        message.warning('已放至最大！')
        return
      }
      setZoom(_zoom)
      // imgDom.style.transform = `scale( ${_zoom} )`
      imgDom.style.width = imgPX.width * _zoom + 'px'
      imgDom.style.height = imgPX.height * _zoom + 'px'
      // imgDom.style.position = 'absolute'
      // imgDom.style.left = -(_zoom-1)/2*imgPX.width+'px'
      // imgDom.style.top = -(_zoom-1)/2*imgPX.height+'px'
      // imgDom.style.position = 'initial'

      // imgDom.style.transform = `scale( ${_zoom} )`
      // if(_zoom = 1){
      //   imgDom.style.left = "0px"
      //   imgDom.style.top = parseInt(top, 10) + "px"
      //   imgDom.style.position = 'absolute'
      // }
    }
    console.log(_zoom)
  }
  const [pdfModalVisible, setPdfModalVisible] = useState(false) // 控制 PDF 预览模态框的显示与隐藏
  const [pdfUrl, setPdfUrl] = useState('') // 存储当前要预览的 PDF 链接
  // 将 PDF 转为图片
  async function convertPdfToImage(url) {
    try {
      const loadingTask = pdfjs.getDocument(url);
      const pdf = await loadingTask.promise;
      const images = [];

      for (let i = 1; i <= pdf.numPages; i++) {
        const page = await pdf.getPage(i);
        const viewport = page.getViewport({ scale: 1.0 });
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        const renderContext = {
          canvasContext: context,
          viewport: viewport
        };

        await page.render(renderContext).promise;
        images.push(canvas.toDataURL('image/png'));
      }
      return images
      // setPdfImages(images);
    } catch (error) {
      console.error('PDF 转换出错:', error);
      message.error('PDF 转换失败，请稍后重试');
    }
  }
  function handlePreviewPdf(url) {
    const securePdfUrl = url.replace('http://', 'https://')
    setPdfUrl(securePdfUrl)
    convertPdfToImage(securePdfUrl); // 调用转换函数
    setPdfModalVisible(true)
  }
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }
  useEffect(() => {
    if (isOpen) {
      // onDrag()
    }
  }, [isOpen])

  //检测是否图片类型
  function isAssetTypeImage(filename) {
    const extension = filename?.split('.').pop().toLowerCase()
    return ['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].includes(extension)
  }

  //图片加载失败时的处理
  function getFallback(item) {
    let arr = item?.split('.com/') || []
    return arr[0] + '.com/attachment/' + arr[1]
  }

  return (
    // overflow:'hidden',
    <Spin spinning={loading} size="large">
    <div className="home-box" style={{ position: 'relative', width: '100%' }}>
      <Row className={!isSearch && dataSource1.length > 4 ? 'searchBar-box' : 'searchBar-box'} justify="space-between">
        <Col className="home-name">食品安全追溯</Col>
        <Col>
          {/* onClick={e=>{getPageList()}} */}
          {!isSearch && (
            <div
              className="search-btn"
              onClick={e => {
                getPageList()
              }}>
              <SearchOutlined style={{ color: '#ffffff', fontSize: '22px', marginRight: '5px' }} /> 搜索
            </div>
          )}
          {isSearch && (
            <div className="search-btn" onClick={e => setIsSearch(false)}>
              <ArrowLeftOutlined style={{ color: '#ffffff', fontSize: '22px', marginRight: '5px' }} /> 返回
            </div>
          )}
        </Col>
      </Row>
      <div className="table-box">
        {!isSearch && dataSource1.length > 4 && (
          <Row style={{ position: 'relative', padding: '20px 40px 0', height: '605px' }}>
            <Col span={12}>
              <Swiper datalist={dataSource1} click={e => showExaminition(e)}></Swiper>
            </Col>
            <Col span={12}>
              <Swiper datalist={dataSource2} click={e => showExaminition(e)}></Swiper>
            </Col>
          </Row>
        )}
        {!isSearch && dataSource1.length > 0 && dataSource1.length <= 4 && (
          <Row style={{ position: 'relative', height: '605px', boxSizing: 'border-box', padding: '20px 40px' }}>
            <Col span={12}>
              <Table className="no-scroll-table" showHeader={false} columns={columns} pagination={false} dataSource={dataSource1}></Table>
            </Col>
            <Col span={12}>
              <Table className="no-scroll-table" showHeader={false} columns={columns} pagination={false} dataSource={dataSource2}></Table>
            </Col>
          </Row>
        )}
        {!isSearch && dataSource1.length == 0 && (
          <Row
            style={{
              position: 'relative',
              padding: '20px 40px',
              height: '605px',
              boxSizing: 'border-box',
              paddingTop: dataSource1.length <= 6 ? '60px' : 0
            }}>
            <Col span={24}>
              <div className="no-data-box">
                <img src={NoDataImg}></img>
                <div className="no-data-txt">暂无内容~</div>
              </div>
            </Col>
          </Row>
        )}
        {!isSearch && <img className="btm-bg" src={btmBgImg}></img>}
      </div>

      {isSearch && (
        <div className="search-table" style={{ height: page.total > 6 ? '663px' : '605px' }}>
          <Row>
            {dataList.map((item, index) => (
              <Col
                span={12}
                key={index}
                style={{ padding: '16px' }}
                onClick={e => {
                  showExaminition(item)
                }}>
                <Row className="outer-box">
                  <Col>
                    <Image className="inner-image" preview={false} width={110} src={item.picUrl} />
                  </Col>
                  <Col className="inner-cnt">
                    <Row className="row-flex">
                      <Col>
                        <div className="goods-name">{item.productName}</div>
                        <div className="goods-restarount">
                          {item.buyerRestaurantName}——{item.buyerStoreName}
                        </div>
                        <div className="goods-time">采购时间：{item.createTime}</div>
                      </Col>
                      {screenPriceShow != 'ON' ? (
                        <Col className="is-upload">
                          {item.examiningReportPicUrl && (
                            <>
                              <CheckOutlined style={{ color: '#31ADA5' }} />
                              <span style={{ color: '#31ADA5' }}>已上传</span>
                            </>
                          )}
                          {!item.examiningReportPicUrl && (
                            <>
                              <ToTopOutlined style={{ color: '#31ADA5' }} />
                              <span style={{ color: '#31ADA5' }}>未上传</span>
                            </>
                          )}
                        </Col>
                      ) : (
                        <Col className="is-upload">
                          <span style={{ color: '#31ADA5' }}>{'¥' + window.$util.toFixed2(item.payableUnitPrice) + '/' + item.unitName}</span>
                        </Col>
                      )}
                    </Row>
                  </Col>
                </Row>
              </Col>
            ))}
          </Row>
          {dataList.length == 0 && (
            <div className="no-data-box">
              <img src={NoDataImg}></img>
              <div className="no-data-txt">暂无内容~</div>
            </div>
          )}
          <div className="pagination">
            <span>共{page.total}个结果</span>
            {page.currentPage > 1 && (
              <Button
                type="primary"
                shape="round"
                size="small"
                onClick={e => {
                  pageChange(--page.currentPage)
                }}>
                上一页
              </Button>
            )}
            {page.total > page.pageSize * page.currentPage && (
              <Button
                type="primary"
                shape="round"
                size="small"
                onClick={e => {
                  pageChange(++page.currentPage)
                }}>
                下一页
              </Button>
            )}
          </div>
          <div className="btm-search-box">
            <div className="btm-search-inner">
              <div className="SearchComponent_box">
                <div className="select_box">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                    <Select
                      className="search_select left"
                      value={searchParams.restaurantId}
                      placeholder="请选择餐厅"
                      bordered={false}
                      allowClear={true}
                      fieldNames={{
                        label: 'buyerRestaurantName',
                        value: 'buyerRestaurantId'
                      }}
                      onChange={e => {
                        getStoreList(e)
                        getProductNameList({ restaurantId: e })
                      }}
                      suffixIcon={<CaretDownOutlined style={{ color: '#114F93' }} />}
                      options={restaurant}
                    />
                    <Select
                      className="search_select"
                      value={searchParams.storeId}
                      bordered={false}
                      placeholder="请选择窗口(档口)"
                      allowClear={true}
                      fieldNames={{
                        label: 'buyerStoreName',
                        value: 'buyerStoreId'
                      }}
                      suffixIcon={<CaretDownOutlined style={{ color: '#114F93' }} />}
                      onChange={e => {
                        setSearchParams({ ...searchParams, storeId: e })
                        getProductNameList({ storeId: e })
                      }}
                      options={store}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: '15px'
                    }}>
                    <Select
                      className="search_select left"
                      value={searchParams.productName}
                      bordered={false}
                      allowClear={true}
                      labelInValue
                      placeholder="请选择食材名称"
                      suffixIcon={<CaretDownOutlined style={{ color: '#114F93' }} />}
                      onChange={e => {
                        setSearchParams({ ...searchParams, productName: e?.label || null })
                      }}
                      options={list}
                    />

                    <DateTimePicker
                      className="search_select"
                      value={[searchParams.startDate, searchParams.endDate]}
                      bordered={false}
                      showTime={false}
                      allowClear={false}
                      onChange={e => {
                        let result = { startDate: e ? e[0] : null, endDate: e ? e[1] : null }
                        setSearchParams({ ...searchParams, ...result })
                        getRestaurantList(result)
                        getProductNameList({ startDate: e ? e[0] : null, endDate: e ? e[1] : null })
                      }}
                    />
                  </div>
                </div>
                <div
                  className="serach_btn"
                  onClick={() => {
                    getPageList()
                  }}>
                  <SearchOutlined className="search_icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="btm-box">
        <Row gutter={48}>
          <Col span={8}>
            <div className="meal-box" onClick={e => goPage('/main/product')}>
              <div className="img-box">
                <img src={MenuImg}></img>
              </div>
              <div className="meal-txt">今日餐品营养查询</div>
            </div>
          </Col>
          <Col span={16}>
            <Carousel autoplay dots={false}>
              {banner.map((item, index) => (
                <div className="carousel-box" key={index}>
                  <Button className="carousel-more" type="primary" shape="round" size="small" onClick={e => goPage('/main/nutrition-science')}>
                    更多
                    <RightOutlined size="9px" style={{ color: '#ffffff' }} />{' '}
                  </Button>
                  <ImgOrVideo item={item} />
                </div>
              ))}
            </Carousel>
          </Col>
        </Row>

        <div className="rank-list">
          <>{<HotWindow list={selectedHotWindowList} customPic={customPicList} configKeyValue={configValue[0]} />}</>

          <HotProduct list={hotSaleWindowList} customPic={customPicList} configKeyValue={configValue[1]} />
        </div>

        <div className="lost">
          <Carousel dots={false} autoplay style={{ width: '1040px', height: '260px' }}>
            {dbtPicUrl &&
              dbtPicUrl.map((item, index) => (
                <div className="goods-img cover" key={index}>
                  <ImgOrVideoFooter item={item.url} />
                </div>
              ))}
          </Carousel>
          {/* <img src={dbtPicUrl} className='map-img' alt="" onClick={e=>{setIsOpen(true);}} height="auto" /> */}
          {/* <div className='video-box' onClick={e=>goPage("/main/lost-and-found")}>
              <div className='img-box'>
                <img src={ShiwuImg}></img>
              </div>
              <div className='video-txt'>失物招领</div>
            </div> */}
        </div>

        <PageFooter style={{ fontSize: '19px', color: '#747474', width: '100%' }}></PageFooter>
      </div>

      {isModalOpen && (
        <div className="modal-mask">
          <div className="modal-box">
            <img className="good-img" src={goodInfo.picUrl} />
            <Button
              className="modal-close"
              onClick={() => {
                setGoodInfo(null)
                setIsModalOpen(false)
              }}
              type="primary"
              shape="round"
              size="small">
              <CloseOutlined style={{ color: '#ffffff' }} /> 关闭{' '}
            </Button>
            <div className="good-name">{goodInfo.productName}</div>
            <div className="good-rest">
              {goodInfo.buyerRestaurantName}—{goodInfo.buyerStoreName}
            </div>
            {goodInfo.examiningReportPicUrl && (
              <div>
                <div className="title">检测报告</div>
                <div className="good-cnt">
                  <div className="good-cnt-inner">
                    {goodInfo.examiningReportPicUrl.split(',').map((item, index) => (
                      <div
                        key={index}
                        style={{ width: '200px', marginRight: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        {/* <div className="good-time">上传时间 {moment().format('YYYY.MM.DD')}</div> */}
                        {isAssetTypeImage(item) ? (
                          <Image className="exam-img" src={item}></Image>
                        ) : (
                          <Button type="primary" onClick={() => handlePreviewPdf(item)} style={{ borderRadius: '10px' }}>
                            预览 检测报告.PDF
                          </Button>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {goodInfo.supplierReportUrls && (
              <div>
                <div className="title">供应商资质</div>
                <div className="good-cnt">
                  <div className="good-cnt-inner">
                    {goodInfo.supplierReportUrls.split(',').map((item, index) => (
                      <div key={index} style={{ width: '300px', marginRight: '20px' }}>
                        {/* <div className="good-time">上传时间 {moment().format('YYYY.MM.DD')}</div> */}
                        <Image className="exam-img" src={item} fallback={getFallback(item)}></Image>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            {goodInfo.supplierContractUrls && (
              <div>
                <div className="title">供应商合同</div>
                <div className="good-cnt">
                  <div className={goodInfo.supplierContractType == 'IMG' ? "good-cnt-inner" : "good-cnt-inner1"} style={{maxHeight:'500px'}}>
                    {goodInfo.supplierContractType == 'IMG'
                      ? goodInfo.supplierContractUrls.split(',').map((item, index) => (
                        <div key={index} style={{ width: '300px', marginRight: '20px' }}>
                          {/* <div className="good-time">上传时间 {moment().format('YYYY.MM.DD')}</div> */}
                          {<Image mode="widthFix" className="exam-img" src={item}></Image>}
                        </div>
                      ))
                      : goodInfo.supplierContractUrlsToImages.map((item, index) => (
                        item.map((url,uid)=>(
                          <div key={index+'-'+uid} style={{ width: '200px', marginRight: '20px', marginBottom:'8px', display:'inline-block' }}>
                            <Image className="exam-img" src={url}></Image>
                          </div>
                        ))
                      ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <Modal
        title="PDF 预览"
        visible={pdfModalVisible}
        onCancel={() => setPdfModalVisible(false)}
        onOk={() => setPdfModalVisible(false)}
        width={1000}>
        <div style={{ height: '1000px', overflow: 'auto' }}>
          <Document
            file={pdfUrl}
            onLoadSuccess={onDocumentLoadSuccess}
            onLoadError={error => {
              console.error('PDF 加载错误:', error)
            }}>
            {Array.from(new Array(numPages), (el, index) => (
              <Page key={`page_${index + 1}`} pageNumber={index + 1} width={800} />
            ))}
          </Document>
        </div>
      </Modal>
      {isOpen && (
        <div className="modal-mask" onClick={() => setIsOpen(false)}>
          <div className="slick-active">
            <img className="img" src={curDbtPicUrl} width={1040} height={260} alt="" title="可拖动" />
          </div>
          <div className="zoomBox">
            <ZoomOutOutlined onClick={() => imgToSize(false)} />
            <ZoomInOutlined onClick={() => imgToSize(true)} />
            <CloseCircleOutlined onClick={() => setIsOpen(false)} />
          </div>
        </div>
      )}
    </div>
    </Spin>
  )
  function ImgOrVideo({ item }) {
    let suffix = 'mp4'
    if (item.absPicUrl.includes('/NEWS/')) {
      suffix = item.absPicUrl.split('NEWS')[1].split('.')[1].split('?')[0]
    } else {
      suffix = item.absPicUrl.split('.com/')[1].split('.')[1]
    }
    let isVideo =
      item.absPicUrl.includes('.mp4') || item.absPicUrl.includes('.avi') || item.absPicUrl.includes('.mov') || item.absPicUrl.includes('.flv')
    return isVideo ? (
      <video className="carousel-image" autoPlay loop controls src={item.absPicUrl} type={'video/' + suffix}></video>
    ) : (
      <img className="carousel-image" mode="scaleToFill" src={item.absPicUrl} onClick={e => goPage('/main/nutrition-science?id=' + item.id)} />
    )
  }
  function ImgOrVideoFooter({ item }) {
    let isVideo = item.includes('.mp4') || item.includes('.avi') || item.includes('.mov') || item.includes('.flv')
    let suffix = 'mp4'
    if (isVideo) {
      if (item.includes('/NEWS/')) {
        suffix = item.split('NEWS')[1].split('.')[1].split('?')[0]
      } else {
        suffix = item.split('.com/')[1].split('.')[1]
      }
    }

    return isVideo ? (
      <video className="map-img" style={{ width: '1040px', height: '260px' }} autoPlay loop controls src={item} type={'video/' + suffix}></video>
    ) : (
      <img
        className="map-img cover"
        mode="scaleToFill"
        style={{ width: '1040px', height: '260px' }}
        src={item}
        onClick={e => {
          setCurDbtPicUrl(item)
          setIsOpen(true)
        }}
      />
    )
  }
}

// 热门窗口
function HotWindow({ list, customPic, configKeyValue }) {
  console.log('list', list)
  const [isHealth, setIsHealth] = useState(false)
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  useEffect(() => {
    let len = list.length > 0 ? (list.length > 4 ? 4 : list.length) : 1
    setSettings({
      dots: false,
      infinite: true,
      slidesToShow: len,
      slidesToScroll: 1,
      autoplay: true,
      vertical: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      arrows: false
    })
    if (list.length > 0) {
      list.map(v => {
        v.picUrls = v.picUrls?.split(',')
      })
      console.log('list================>', list)
      let isHealth = list.find(v => v.picUrls)
      if (isHealth) {
        setIsHealth(true)
      } else {
        setIsHealth(false)
      }
    }
  }, [list.length])
  let customPicUrl = 'https://cdn.rongdaufun.com/spa/other/scImgs/rmck.png'
  if (configKeyValue == 2) {
    let pic = customPic[0]
    customPicUrl = pic ? pic[0].url : 'https://cdn.rongdaufun.com/spa/other/scImgs/rmck.png'
  }

  function ImgOrVideo({ item }) {
    let isVideo = item.includes('.mp4') || item.includes('.avi') || item.includes('.mov') || item.includes('.flv')
    let suffix = 'mp4'
    if (isVideo) {
      // console.log('video',item)
      if (item.includes('/NEWS/')) {
        suffix = item.split('NEWS')[1].split('.')[1].split('?')[0]
      } else {
        suffix = item.split('.com/')[1].split('.')[1]
      }
    }

    return isVideo ? (
      <video className="goods-img cover" autoPlay loop controls src={item} type={'video/' + suffix}></video>
    ) : (
      <img className="goods-img cover" mode="scaleToFill" src={item} />
    )
  }
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function openModal(item) {
    setModal({ visible: true, info: item })
  }
  function closeModal() {
    setModal({ visible: false, info: null })
  }
  return (
    <>
      <div className="rank hot-window" style={{ background: `url('${fireBg}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
        {
          configKeyValue == 1 ? (
            <>
              <div className="rank-header">{isHealth ? '健康证' : '热门窗口'}</div>
              <div className="rank-body">
                <SliderComponent {...settings} className="slider-inner" style={{ height: '276px' }}>
                  {list.map((item, i) => (
                    <div key={i}>
                      <div className="inner-item">
                        <div className="item-rest">{isHealth ? item.buyerRestaurantName : item.restaurantName}</div>
                        <div className="item-store">{isHealth ? item.buyerStoreName : item.windowName}</div>
                        <div className="item-value-outer">
                          {isHealth ? (
                            item.picUrls && item.picUrls.length > 0 ? (
                              <img className="corner-img" src={fireHealth} />
                            ) : (
                              ''
                            )
                          ) : (
                            <img className="corner-img" src={fireRedCornerImg} />
                          )}
                          {
                            isHealth ? (
                              item.picUrls && item.picUrls.length > 0 ? (
                                <div style={{ color: '#3FA5FF' }} onClick={() => openModal(item)}>
                                  查看健康证
                                </div>
                              ) : (
                                '暂无健康证'
                              )
                            ) : (
                              <div className="item-value">{item.hotValue}</div>
                            )
                            // (item.healthImg && item.healthImg.length > 0) ? <div style={{ color: '#3FA5FF' }} onClick={() => openModal(item)}>查看健康证</div> : <div className="item-value">{item.hotValue}</div>
                          }
                        </div>
                      </div>
                    </div>
                  ))}
                </SliderComponent>
                {/* <img className="body-bg" src={fireBgImg} /> */}
              </div>
            </>
          ) : (
            <Carousel autoplay dots={false}>
              {customPic &&
                customPic[0] &&
                customPic[0].map((item, index) => (
                  <div className="goods-img cover" key={index}>
                    <ImgOrVideo item={item.url} />
                  </div>
                ))}
            </Carousel>
          )
          // <ImgOrVideo item={customPicUrl}></ImgOrVideo>
          // <img className="goods-img cover" src={customPicUrl} />
        }
      </div>
      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={modal.visible && modal.info.picUrls?.length > 4 ? 782 : ''}>
        {modal.info && (
          <div className="modal-main">
            <div className="health-item">
              {modal.info.picUrls?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

// 热销商品
function HotProduct({ list, customPic, configKeyValue }) {
  let _list = []
  // let customPicUrl = 'https://cdn.rongdaufun.com/spa/other/scImgs/rxsp.png'
  if (configKeyValue == 2) {
    let pic = customPic[1]
    // customPicUrl = pic?pic[0].url : 'https://cdn.rongdaufun.com/spa/other/scImgs/rxsp.png'
  } else {
    _list = _.chunk(list, 3)
  }
  console.log('_list', _list)
  const [settings, setSettings] = useState({
    dots: false,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    vertical: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    arrows: false
  })
  function ImgOrVideo({ item }) {
    let isVideo = item.includes('.mp4') || item.includes('.avi') || item.includes('.mov') || item.includes('.flv')
    let suffix = 'mp4'
    if (isVideo) {
      if (item.includes('/NEWS/')) {
        suffix = item.split('NEWS')[1].split('.')[1].split('?')[0]
      } else {
        suffix = item.split('.com/')[1].split('.')[1]
      }
    }

    return isVideo ? (
      <video className="goods-img cover" autoPlay loop controls src={item} type={'video/' + suffix}></video>
    ) : (
      <img className="goods-img cover" mode="scaleToFill" src={item} />
    )
  }
  const [modal, setModal] = useState({
    visible: false,
    info: null
  })
  function openModal(item) {
    setModal({ visible: true, info: item })
  }
  function closeModal() {
    setModal({ visible: false, info: null })
  }

  return (
    <>
      <div className="rank hot-product" style={{ background: `url(${hotBg})`, backgroundRepeat: 'no-repeat' }}>
        {
          configKeyValue == 1 ? (
            <>
              <div className="rank-header">{storeUser.getState().sysuserInfo.buyerOrgId == '27' ? '供应商合同' : '热销商品'}</div>
              <div className="rank-body">
                <SliderComponent {...settings} className="slider-inner">
                  {_list.map((item, i) => (
                    <div key={i}>
                      <div className="inner-item">
                        {item[0] && (
                          <div className="goods" onClick={() => openModal(item[0])}>
                            {item[0].pic.length > 0 ? (
                              <div style={{ width: '100%', height: '100%' }}>
                                <img className="goods-img" src={item[0].pic[0].url} />
                                <div className="goods-corner">
                                  <img className="corner-img" src={fireCornerImg} />
                                  <div className="corner-text">{item[0].hotValue}</div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                        {item[1] && (
                          <div className="goods" onClick={() => openModal(item[1])}>
                            {item[1].pic.length > 0 ? (
                              <div style={{ width: '100%', height: '100%' }}>
                                <img className="goods-img" src={item[1].pic[0].url} />
                                <div className="goods-corner">
                                  <img className="corner-img" src={fireCornerImg} />
                                  <div className="corner-text">{item[1].hotValue}</div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                        {item[2] && (
                          <div className="goods">
                            {item[2].pic.length > 0 ? (
                              <div style={{ width: '100%', height: '100%' }}>
                                <img className="goods-img" src={item[2].pic[0].url} onClick={() => openModal(item[2])} />
                                <div className="goods-corner">
                                  <img className="corner-img" src={fireCornerImg} />
                                  <div className="corner-text">{item[2].hotValue}</div>
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </SliderComponent>
              </div>
            </>
          ) : (
            <Carousel autoplay dots={false}>
              {customPic &&
                customPic[1] &&
                customPic[1].map((item, index) => (
                  <div className="goods-img cover" key={index}>
                    <ImgOrVideo item={item.url} />
                  </div>
                ))}
            </Carousel>
          )
          // <ImgOrVideo item={customPicUrl}></ImgOrVideo>
          // <img className="goods-img cover" src={customPicUrl} />
        }
      </div>

      <Modal
        className="pages_main_home_HotProduct_modal"
        open={modal.visible}
        onCancel={closeModal}
        footer={null}
        centered
        closable={false}
        width={719}>
        {/* {modal.info && (
          <div className="modal-main">
            <img className="modal-img" src={modal.info.picAbs.url} />
            <div className="modal-bottom">
              <div className="modal-goods-name">{modal.info.goodsName}</div>
              <div className="modal-store-name">{modal.info.windowName}</div>
            </div>
          </div>
        )} */}
        {modal.info && (
          <div className="modal-main" style={{ backgroundColor: '#CECECE' }}>
            <div className="modal-bottom">
              <div className="modal-store-name">{modal.info.goodsName}</div>
              <div className="modal-store-name" style={{ marginLeft: '20px' }}>
                {modal.info.windowName}
              </div>
            </div>
            <div className="health-item">
              {modal.info.pic?.map(v => {
                //
                return (
                  <div style={{ marginRight: '7px' }}>
                    <Image width={183} height={183} src={v.url} alt="背景" key={v.id}></Image>
                  </div>
                )
              })}
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}
